import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DocumentVerificationFormResponse } from "../model/DocumentVerificationFormResponse";
import { FileResponseModel } from "../model/FileResponseModel";
import { DocumentVerificationResponse } from "../model/DocumentVerificationResponse";
import { ViewDocumentDetailModel } from "../model/ViewDocumentDetailModel";
import { Page } from "../model/Page";
import { PaymentSettlementModel } from "../model/PaymentSettlementModel";
import { ViewApplicationSearchModel } from "../model/ViewApplicationSearchModel";
import { AuditTrailModel } from "../model/AuditTrailModel";

@Injectable({
  providedIn: "root",
})
export class DocumentVerificationService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  getLotteryName() {
    return this.httpClient.get<DocumentVerificationFormResponse>(ApiUrls.initDocVerLotteryName);
  }

  getSchemeName() {
    return this.httpClient.get<DocumentVerificationFormResponse>(ApiUrls.initDocVerSchemeName);
  }

  getSchemeList(lotteryEventId : any) {
    return this.httpClient.get<{
      schemeList: {[key: number]: string}, 
    }>(
      ApiUrls.initDocVerSchemeList.replace(
        "{lotteryEventId}",lotteryEventId
      )
      );
  }
  fetchDetailView(applicationNo: number) {
    return this.httpClient.get<ViewDocumentDetailModel>(
      ApiUrls.viewDocumentDetail.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }

  fetchAuditDetailView(applicationNo: number) {
    return this.httpClient.get<ViewDocumentDetailModel>(
      ApiUrls.viewAuditDocDetail.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }

  fetchPaymentDetailView(applicationNo: number) {
    return this.httpClient.get<Page<ViewDocumentDetailModel>>(
      ApiUrls.getDocumentDetailsList.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }

  getAccountOfficerConfirmedList(
    lotteryEventId: number,
    statusId: string,
    schemeId:any,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getDocumentVerificationConfirmedList
        .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId)
        .replace(`{schemeId}`,schemeId) + reqParams
    );
  }
  getAccountOfficerFilterList(
    lotteryEventId: number,
    statusId: string,
    schemeId: any,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getDocumentVerificationFilterList
        .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) 
        .replace(`{schemeId}`,schemeId)+ reqParams
    );
  }
  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  fetchAsFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAsFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchForm16BFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchForm16BFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchQbFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchQbFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }

  fetchChallanFile(asFile: string, applicationNo: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchChallanFile
        .replace("{asFile}", asFile)
        .replace("{applicationNo}", applicationNo.toString())
    );
  }


  statusFile(status:any,applicationNo : string) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveTdsStatus.replace("{applicationNo}", applicationNo)+"?status="+status}`,null
    );
  }

  rejectedStatusFile(remark: string ,status:any,applicationNo : string){
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveRejectTdsStatus
        .replace("{remark}", remark)
        .replace("{applicationNo}", applicationNo)
        +"?status="+status}`,null
     );
  }

  submitVerificationDetail(applicationNo: number, nocStatus: string,
    rejectReason: string, outwardNo: string) {
    return this.httpClient.post<{status: string, applicationNo: string, url: string, errorMessage: string}>(
      ApiUrls.beforAllotmentApproverDetail.replace('{applicationNo}', 
      applicationNo.toString()) , {
        nocStatus: nocStatus,
        outwardNo: outwardNo,
        rejectReason: rejectReason
    });
  }
  
  getBeforPolDocumentVerificationConfirmedList(
    lotteryEventId: number,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getBeforePolDocumentVerificationConfirmedList
        .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) + reqParams
    );
  }
   
  getBeforPolDocumentVerificationFilterList(
    lotteryEventId: number,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getBeforePolDocumentVerificationFilterList
        .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) + reqParams
    );
  }

  fetchBeforePolDetailView(applicationNo: number) {
    return this.httpClient.get<ViewDocumentDetailModel>(
      ApiUrls.viewPolDocumentDetail.replace(
        "{applicationNo}",
        applicationNo.toString()
      )
    );
  }


  submitPolVerificationDetail(applicationNo: number, nocStatus: string,
    rejectReason: string, outwardNo: string) {
    return this.httpClient.post<{status: string, applicationNo: string, url: string, errorMessage: string}>(
      ApiUrls.beforPolApproverDetail.replace('{applicationNo}', 
      applicationNo.toString()) , {
        nocStatus: nocStatus,
        outwardNo: outwardNo,
        rejectReason: rejectReason
    });
  }

  fetchFilterList(
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getFilterList + reqParams
        
    );
  }

  importLetter(lotteryKey: number, type: string, base64: string | ArrayBuffer) {
    return this.httpClient.post<{status: string, errorMessage: string, sucessMessage: string}>(
      ApiUrls.importDocumentsUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{type}', type.toString()), {
        bas64Data: base64
    });
  }

  updatePossession(
    filterText?: string
  ) {
    let reqParams =
      (filterText ? `?filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.updatepossisionComplete + reqParams
        
    );
  }

  getEngineerDocumentVerificationConfirmedList(
    lotteryEventId: number,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<DocumentVerificationResponse>>(
      ApiUrls.getEngineerDocumentVerificationConfirmedList
        .replace(`{lotteryEventId}`, lotteryEventId.toString())
        .replace(`{statusId}`, statusId) + reqParams
    );
  }

  fetchAuditTrail(
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AuditTrailModel>>(
      ApiUrls.getAuditTrail + reqParams
        
    );
  }
}
